import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  title: string;
  message: string;
  action: string;
}

@Component({
  selector: "vp-confirm",
  standalone: false,
  styleUrls: ["./confirmation-dialog.component.scss"],
  templateUrl: "./confirmation-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
